import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Special Episode: Squid Game, Explaining the Childhood Games and Important Themes</h1>
                        <h5 className="korean-title">특별 에피소드: 오징어게임의 게임과 사회적인 문제들</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

딱지 (ddakji) — traditional South Korean game played using folded paper tiles (pictured below) <br></br>
Try making your own ddakji <a href="https://www.thesprucecrafts.com/how-to-make-korean-ddakji-game-2541008" target="_blank">here</a>! It's so easy—all you ned is paper.<br></br>
<img className="epPic-m" src="https://pbs.twimg.com/media/D_Nf8j6WwAMnfge.jpg"></img><br></br>
<img className="epPic-m" src="https://staticg.sportskeeda.com/editor/2021/09/3314f-16323361711807-800.jpg"></img><br></br><br></br>

무궁화 꽃이 피었습니다 (mugunghwa kkoti pieutseupnida) — Korea's version of red light green light (literally translates to 'The hibiscus flower has bloomed') <br></br>
<img className="epPic-m" src="https://pds.joongang.co.kr/news/component/htmlphoto_mmdata/202109/25/3d358dd1-746a-43be-8bf4-42ae3f1b5b94.jpg"></img><br></br><br></br>

달고나/뽑기 (dalgona/ppopki) —  Korean candy made with melted sugar and baking soda (pictured below) <br></br>
<img className="epPic-m" src="https://images.indianexpress.com/2021/10/DALGONA-CANDY.jpg"></img><br></br>
<img className="epPic-m" src="https://sm.mashable.com/mashable_sea/photo/default/squid-game-dalgona-cookie-header_geq6.png"></img><br></br><br></br>


줄다리기 (juldarigi) — tug of war <br></br>
<img className="epPic-m" src="https://cdn.clien.net/web/api/file/F01/12069072/179c8fda9c0292.jpg"></img><br></br>
<img className="epPic-m" src="http://www.globalnewsagency.kr/news/photo/201805/94623_84903_4715.jpg"></img><br></br><br></br>


<br></br><br></br>
Import issues that Squid Game brings up:<br></br>
1. Economic insecurity and poverty<br></br>
2. Gender discrimination<br></br>
3. Mistreatment of migrant workers<br></br>
4. North Korean defectors <br></br>
5. Behind-the-scenes imperialism of Korea by Western powers<br></br>
6. Massacres that reflect Korean history<br></br>



                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;